const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

// Policy: API/DB timestamps are UTC ISO strings; all UI formatters render the
// browser's local timezone so users see wall-clock time that matches their
// environment. Jest runs under TZ=UTC for stable assertions.
function localDateParts(date: Date): {
  day: string;
  month: string;
  year: string;
} {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear());
  return { day, month, year };
}

/** Short calendar date: "DD MMM. YYYY" (local). */
export function formatShortDate(iso: string | null): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  const day = String(date.getDate()).padStart(2, '0');
  const month = MONTHS[date.getMonth()];
  const year = date.getFullYear();
  return `${day} ${month}. ${String(year)}`;
}

export function formatDocDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  const { day, month, year } = localDateParts(date);
  return `${day}.${month}.${year}`;
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  const { day, month, year } = localDateParts(date);
  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');
  const ss = String(date.getSeconds()).padStart(2, '0');
  return `${day}.${month}.${year} ${hh}:${mm}:${ss}`;
}

/** Local date-time to the minute: "DD.MM.YYYY HH:mm". */
export function formatScheduledDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  const { day, month, year } = localDateParts(date);
  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');
  return `${day}.${month}.${year} ${hh}:${mm}`;
}
